import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'BONO 1 — RESET MENTAL EXPRESS',
    desc: 'El protocolo de 2 minutos para cuando tu cabeza colapsa en medio del día. 5 pasos de emergencia para recuperar la claridad al instante.',
    value: '29€'
  }, {
    num: '02',
    title: 'BONO 2 — CHECKLIST DE CIERRE DIARIO',
    desc: 'La rutina de 5 minutos para cerrar el día de trabajo y desconectar el cerebro antes de dormir. Nunca más te irás a la cama con la cabeza abierta.',
    value: '19€'
  }, {
    num: '03',
    title: 'BONO 3 — PACK ANTI-RUIDO DIGITAL',
    desc: 'Plantilla visual descargable para externalizar ideas complejas, proyectos bloqueados y decisiones pendientes. Saca todo de la cabeza y ponlo en papel.',
    value: '19€'
  }, {
    num: '04',
    title: 'BONO 4 — GUÍA 10 MINUTOS: VOLVER AL CONTROL',
    desc: 'Guía de audio-ambientes y frecuencias sonoras diseñadas para entrar en estado de Flow en menos de 5 minutos. Ideal para trabajo profundo o descanso activo.',
    value: '29€'
  }];
  return <Section data-id="element-42">
      <div className="text-center mb-12" data-id="element-43">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-44">
          🎁 4 BONOS ESTRATÉGICOS
        </h2>
        <span className="inline-block bg-brand-accent text-black font-bold px-4 py-1 rounded-full text-sm tracking-wider" data-id="element-45">
          SIEMPRE INCLUIDOS
        </span>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-46">
        {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-8 relative overflow-hidden group hover:border-brand-accent/30 transition-colors" data-id="element-47">
            <div className="absolute -right-4 -top-4 text-8xl font-black text-neutral-900 opacity-50 group-hover:text-neutral-800 transition-colors" data-id="element-48">
              {bonus.num}
            </div>
            <div className="relative z-10" data-id="element-49">
              <div className="text-2xl mb-4" data-id="element-50">🎁</div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-51">
                {bonus.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed mb-6" data-id="element-52">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-3" data-id="element-53">
                <span className="text-neutral-500 line-through text-lg" data-id="element-54">
                  {bonus.value}
                </span>
                <span className="text-brand-accent font-bold text-xl" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 max-w-md mx-auto text-center flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-56">
        <div data-id="element-57">
          <div className="text-neutral-400 text-sm mb-1" data-id="element-58">Valor total bonos</div>
          <div className="text-2xl font-bold text-neutral-500 line-through" data-id="element-59">
            96€
          </div>
        </div>
        <div className="hidden md:block text-neutral-600 text-3xl" data-id="element-60">→</div>
        <div data-id="element-61">
          <div className="text-neutral-400 text-sm mb-1" data-id="element-62">Con tu Kit</div>
          <div className="text-3xl font-bold text-brand-accent" data-id="element-63">GRATIS</div>
        </div>
      </div>
    </Section>;
}